import React from "react";
import { Row, Col, Form, FormGroup, Label, Input, Card, CardBody } from "reactstrap";
import { NotificationSettingsValues, SettingsProps } from "../../types/settings";
import SettingsButtons from "./SettingsButtons";
import { Formik } from "formik";
import { notificationSettingsValidation } from "rules/settings";

const NotificationSettings: React.FC<SettingsProps> = ({ 
  onGlobalCancel, 
  isSaving, 
  onSave 
}) => {
  const initialValues: NotificationSettingsValues = {
    orderNotifications: false,
    customerMessages: false,
    stockAlerts: false,
    securityAlerts: false,
    notificationEmails: "",
  };

  const handleSave = async (values: NotificationSettingsValues) => {
    await onSave(async () => {
      console.log("Form submitted with values:", values);
      await new Promise(resolve => setTimeout(resolve, 1000));
      // TODO: Add actual API call here
    });
  };

  return (
    <div className="bg-transparent">
      <h5 className="mb-4">Notification Settings</h5>
      <Formik
        initialValues={initialValues}
        validationSchema={notificationSettingsValidation}
        onSubmit={handleSave}
        validateOnMount={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form>
            <Card className="mb-4">
              <CardBody>
                <h6 className="mb-3">Email Notifications</h6>
                <Row>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="orderNotifications"
                        name="orderNotifications"
                        onChange={handleChange}
                        checked={values.orderNotifications}
                      />
                      <Label check for="orderNotifications">
                        New Order Notifications
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="customerMessages"
                        name="customerMessages"
                        onChange={handleChange}
                        checked={values.customerMessages}
                      />
                      <Label check for="customerMessages">
                        Customer Messages
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Push Notifications</h6>
                <Row>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="stockAlerts"
                        name="stockAlerts"
                        onChange={handleChange}
                        checked={values.stockAlerts}
                      />
                      <Label check for="stockAlerts">
                        Low Stock Alerts
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="securityAlerts"
                        name="securityAlerts"
                        onChange={handleChange}
                        checked={values.securityAlerts}
                      />
                      <Label check for="securityAlerts">
                        Security Alerts
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Notification Recipients</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="notificationEmails">Additional Email Recipients</Label>
                      <Input
                        type="textarea"
                        id="notificationEmails"
                        name="notificationEmails"
                        rows={3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.notificationEmails}
                        placeholder="Enter email addresses (one per line)"
                      />
                      {touched.notificationEmails && errors.notificationEmails && (
                        <div className="text-danger mt-1">{errors.notificationEmails}</div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <SettingsButtons
              onSave={handleSubmit}
              onCancel={onGlobalCancel}
              saveDisabled={Object.keys(errors).length > 0}
              isSaving={isSaving}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default NotificationSettings; 